import { createServiceBuilder } from "./lib";
import { requestNew } from "./ChangeService";
import { injectedWorkspaceSlice } from "./reducer";
const { actions, selectors } = injectedWorkspaceSlice;
export const WorkspaceServiceBuilder = createServiceBuilder({
    name: 'WorkspaceService',
    api: ({ ChangeService, EditorsService, ResourceTreeService }) => ({
        actions,
        selectors,
        openResource: (input) => (dispatch) => {
            dispatch(EditorsService.open({ resourceID: input }));
            dispatch(ResourceTreeService.actions.setSelectedResourceID(input));
        },
        createNew: (resourceType) => async (dispatch) => {
            const newResource = await dispatch(ChangeService.commit(requestNew({
                resourceType,
                origin: 'global',
            })));
            dispatch(ResourceTreeService.actions.setSelectedResourceID(newResource.id));
            dispatch(EditorsService.actions.createEditorTab({ resourceID: newResource.id }));
        }
    }),
});
//# sourceMappingURL=WorkspaceService.js.map